module.exports = __webpack_public_path__ + "static/media/earlyDecisionBlueIcon.a4953990.svg";